export default "__VITE_ASSET__bc8578d8__"